<template>
  <div class="page about">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title">Support</span>
      <HeaderNav />
    </div>

    <div class="page-content" v-if="acf">
      <Components :components="pageData.acf.components" location="above" />
      <Components :components="pageData.acf.components" location="below" />
      <Footer />
    </div>
  </div>
</template>

<script>
import SubPageUtils from '../mixins/SubPageUtils';

import Components from '../components/Components';
import HeaderNav from '../components/HeaderNav';
import Footer from '../components/Footer';

export default {
  name: 'Support',
  components: { Components, HeaderNav, Footer },
  mixins: [SubPageUtils],
  data() {
    return {
      pageData: {},
    }
  },
  computed: {
    acf() {
      if (this.pageData.acf) return this.pageData.acf;
    }
  },
  async mounted() {
    const pageDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/wp/v2/pages/19104`)
    this.pageData = await pageDataResponse.json();
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.page.about {
  h2 {
    min-width: 25%;
    margin: 0 50px 40px 0;
  }
  p {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Support.vue